import ApiServer from '@/utils/api/ApiServer.js'
import { TractHudSection } from '@/utils/Enumerations.js'

let inFlight = null

export default {
  fetchTractHudSections (context) {
    if (inFlight) return inFlight
    context.commit('setTractHudSectionsLoading', true)
    inFlight = ApiServer.get('tracthudsections')
      .then(response => {
        const sortedData = TractHudSection.sortedByPriority(response.data)
        context.commit('setTractHudSections', sortedData)
        return sortedData
      })
      .finally(() => {
        context.commit('setTractHudSectionsLoading', false)
        inFlight = null
      })
    return inFlight
  },

  async updateTractHudSections (context, tractHudSections) {
    const response = await ApiServer.put('tracthudsections', tractHudSections)
    const sortedData = TractHudSection.sortedByPriority(response.data)
    context.commit('setTractHudSections', sortedData)
    return sortedData
  }
}
